export default __webpack_public_path__ + "static/assets/382b3239922223bd857c0251c39be6d2.png";